import React from 'react';
import { useTranslation } from 'react-i18next';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import { PageTitle } from '../../styles/GlobalComponents';
import { color } from '../../styles/GlobalStyles';
import {
  Icon,
  IconCompensationPlan,
  IconPresentation,
  IconMediaKit
} from '../../styles/Icons';

import {
  HeaderIcon,
  ResourcesBody,
  ResourcesContainer,
  ResourcesHeader,
  Title
} from './ResourcesStyled';

export const Resources = () => {
  const { t } = useTranslation('resources');
  return (
    <AnimatedDashboard zoom>
      <PageTitle>{t('resources')}</PageTitle>
      <ResourcesContainer>
        <ResourcesHeader>
          <HeaderIcon>
            <Icon color={color.colors.neutral50}>
              <IconPresentation />
            </Icon>
          </HeaderIcon>

          <Title>{t('presentation')}</Title>
        </ResourcesHeader>
        <ResourcesBody>
          <a
            href='https://resources.mavie.global/presentations/Travelution_Presentation_Plan.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution presentation ( ENG )</li>
          </a>
        </ResourcesBody>
        {/* <ResourcesBody>
          <a
            href='https://resources.mavie.global/presentations/Travelution_Presale_Presentation.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution video presentation ( ENG )</li>
          </a>
        </ResourcesBody> */}
      </ResourcesContainer>

      <ResourcesContainer>
        <ResourcesHeader>
          <HeaderIcon>
            <Icon color={color.colors.neutral50}>
              <IconCompensationPlan />
            </Icon>
          </HeaderIcon>

          <Title>Compensation Plan</Title>
        </ResourcesHeader>
        <ResourcesBody>
          <a
            href='https://resources.mavie.global/presentations/Travelution_Compensation_Plan.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution compensation plan ( ENG )</li>
          </a>
        </ResourcesBody>
      </ResourcesContainer>
    </AnimatedDashboard>
  );
};
